export const chatbotWidgetState = (state) => state.general?.openChatWidget;

export const bearerToken = (state) => state.general?.bearerToken;

export const isVerifyEmailOptionVisible = (state) => state.general?.isVerifyEmailOptionVisible;

export const verifyEmailTimer = (state) => state.general?.verifyEmailTimer;

export const companyInformation = (state) => state?.auth?.userData?.user?.company ?? {};
